import {
    addDocument,
    queryDocuments,
    getDocumentById,
    updateDocument,
    batchUpdate
} from "../firebase/firestore";

export const creditService = {
    async assignCredit(data) {
        const creditId = await addDocument("credits", {
            assignedBy: data.assignedBy,
            assignedTo: data.assignedTo,
            teamId: data.teamId || null,
            amount: data.amount,
            activityType: data.activityType,
            description: data.description,
            isTeamCredit: data.isTeamCredit || false,
            approvalStatus: "approved",
            createdAt: new Date(),
            updatedAt: new Date()
        });

        if (data.isTeamCredit && data.teamId) {
            await this.distributeTeamCredits(data.teamId, data.amount, creditId);
        } else if (data.assignedTo) {
            await this.addCreditToUser(data.assignedTo, data.amount);
        }

        return creditId;
    },

    async distributeTeamCredits(teamId, amount, creditId) {
        const teamMembers = await queryDocuments("teams", [["id", "==", teamId]]);

        if (teamMembers.length > 0) {
            const team = teamMembers[0];
            const memberIds = team.members || [];

            const updates = memberIds.map((memberId) => ({
                collectionName: "users",
                docId: memberId,
                data: {
                    totalCredits: (team.memberCredits?.[memberId] || 0) + amount
                }
            }));

            await batchUpdate(updates);
        }
    },

    async addCreditToUser(userId, amount) {
        const user = await getDocumentById("users", userId);
        const currentCredits = user?.totalCredits || 0;

        await updateDocument("users", userId, {
            totalCredits: currentCredits + amount
        });
    },

    async getCreditHistory(userId, limit = 50) {
        return await queryDocuments(
            "credits",
            [["assignedTo", "==", userId]],
            { field: "createdAt", direction: "desc" },
            limit
        );
    },

    async getUserTotalCredits(userId) {
        const user = await getDocumentById("users", userId);
        return user?.totalCredits || 0;
    },

    async getCreditsByActivity(activityType, limit = 100) {
        return await queryDocuments(
            "credits",
            [["activityType", "==", activityType]],
            { field: "createdAt", direction: "desc" },
            limit
        );
    },

    async getTopContributors(limit = 10) {
        return await queryDocuments(
            "users",
            [["role", "==", "student"]],
            { field: "totalCredits", direction: "desc" },
            limit
        );
    }
};

export default creditService;
